import styled from 'styled-components';

import { HEADER_HEIGHT } from 'src/common/constants';
import { StyledFlexContainer } from 'src/components/core/layout/FlexContainer';

export const DrawerContainer = styled.div`
    & > div {
        width: 435px;
        ${({ theme: { colors, breakpoints } }) => `
            @media (max-width: ${breakpoints.md}) {
                width: 320px;
            }
            & > .drawer-content {
                width: 435px;
                background-color: ${colors.background.secondary.v5};
                height: calc(100% - ${HEADER_HEIGHT});
                display: flex;
                flex-direction: column;
                @media (max-width: ${breakpoints.md}) {
                    width: 320px;
                }
                & > .coinTabs {
                    margin-top: 24px;
                    border-bottom: 1px solid ${colors.border.dark};
                    & > .tab {
                        & > svg {
                            margin-right: 8px;
                            padding: 0px !important;
                        }
                    }
                }
            }
        `}
    }
`;

export const DrawerHeader = styled(StyledFlexContainer)`
    justify-content: space-between;
    padding: 24px;
    ${({ theme: { typography, breakpoints } }) => `
        & > span {
            font-size: ${typography.size.desktop.heading.h6};
            font-weight: ${typography.weight.medium};
            line-height: calc(${typography.lineHeight[7]} - 1px);
        }
        @media (max-width: ${breakpoints.md}) {
            padding: 16px;
            & > span {
                font-size: ${typography.size.mobile.heading.h5};
                line-height: calc(${typography.lineHeight[5]} + 0.5px);
            }
        }
    `}
`;

export const DrawerSearchContainer = styled(StyledFlexContainer)`
    position: relative;
    ${({ theme: { colors, typography, breakpoints } }) => `
        & > input {
            width: 100%;
            height: 40px;
            margin: 0 24px;
            padding: 10px 44px;
            border-radius: 50px;
            border: 1px solid ${colors.border.dark};
            outline: none;
            background: transparent;
            color: ${colors.text.primary};
            line-height: ${typography.lineHeight[6]};
            font-size: ${typography.size.desktop.paragraph.p2};
            &:focus-visible {
                border: 1px solid ${colors.primary};
            }
            @media (max-width: ${breakpoints.md}) {
                margin: 0 16px;
                padding: 10px 36.74px;
            }
            ::placeholder {
                color: ${colors.text.tertiary};
                opacity: 1;
            }

            :-ms-input-placeholder {
                color: ${colors.text.tertiary};
            }

            ::-ms-input-placeholder {
                color: ${colors.text.tertiary};
            }
        }
        & > svg:first-of-type {
            position: absolute;
            left: 40px;
            @media (max-width: ${breakpoints.md}) {
                left: 27.31px;
            }
        }
    `}
    & > svg:last-of-type {
        position: absolute;
        right: 34px;
    }
`;

export const DrawerCoinListHeader = styled(StyledFlexContainer)`
    ${({ theme: { colors, typography, isMobile } }) => `
        margin-top: ${isMobile ? '16px' : '24px'};
        padding: ${isMobile ? '7.5px 16px' : '6px 16px'};
        color: ${colors.text.tertiary};
        font-size: ${
            isMobile ? typography.size.mobile.paragraph.p3 : typography.size.desktop.paragraph.p3
        };
    `}
    & > div {
        &:nth-of-type(1) {
            width: 50%;
            justify-content: start;
        }
        &:nth-of-type(2) {
            width: 50%;
            justify-content: end;
        }
    }
`;

export const DrawerCoinListContainer = styled(StyledFlexContainer)`
    width: 100%;
    height: 100%;
    flex-direction: column;
    margin-top: 16px;
    gap: 24px;
    overflow-y: scroll;
    ${({ theme: { breakpoints, isMobile } }) => `
        padding: ${isMobile ? '0 10px 0 16px' : '0px 10px 0px 16px'};
        @media (max-width: ${breakpoints.md}) {
            margin-top: 10px;
            height: calc(100vh - 267px);
        }
    `}
`;

export const DrawerCoinListItem = styled(StyledFlexContainer)`
    ${({ theme: { colors, typography, isMobile } }) => `
    width: 100%;
    gap: 8px;

    .favoriteButton {
      cursor: pointer;
    }

    .pairDetails {
      display: flex;
      justify-content: space-between;
      width: 100%;
      cursor: pointer;
    }

    .pairInfo {
      width: 100%;
      align-items: start;
      flex-direction: column;

      .symbolName {
        font-size: ${
            isMobile ? typography.size.mobile.paragraph.p1 : typography.size.desktop.paragraph.p2
        };
        line-height: ${typography.lineHeight[6]};
        font-weight: ${typography.weight.semiBold};
      }

      .quoteValue {
        color: ${colors.text.tertiary};
        font-size: ${
            isMobile ? typography.size.mobile.paragraph.p2 : typography.size.desktop.paragraph.p2
        };
        line-height: ${isMobile ? typography.lineHeight[2] : typography.lineHeight[6]};
        letter-spacing: ${isMobile ? '-0.24px' : 'normal'};
      }
    }

    .priceInfo {
      width: 50%;
      align-items: end;
      flex-direction: column;

      .currentPrice {
        font-size: ${
            isMobile ? typography.size.mobile.paragraph.p1 : typography.size.desktop.paragraph.p2
        };
        line-height: ${typography.lineHeight[6]};
      }

      .priceChange {
        color: ${colors.text.tertiary};
        font-size: ${
            isMobile ? typography.size.mobile.paragraph.p2 : typography.size.desktop.paragraph.p2
        };
        line-height: ${isMobile ? typography.lineHeight[2] : typography.lineHeight[6]};
        letter-spacing: ${isMobile ? '-0.24px' : 'normal'};
      }
    }
  `}
`;

export const NoRecordContainer = styled(StyledFlexContainer)`
    flex-direction: column;
    margin-top: 60px;
    ${({ theme: { colors, typography, breakpoints } }) => `
        & > p {
            margin-top: 4px;
            color: ${colors.text.tertiary};
            font-size: ${typography.size.desktop.paragraph.p2};
            line-height: calc(${typography.lineHeight[3]} - 0.5px);
        }
        & > button {
            margin-top: 24px;
            @media (max-width: ${breakpoints.md}) {
                margin-top: 16px;
            }
        }
    `}
    &.no-result {
        margin-top: 68px;
    }
    &.no-favorites {
        margin-top: 40px;
    }
`;

export const DrawerHoldingCoinListHeader = styled(StyledFlexContainer)`
    ${({ theme: { colors, typography, isMobile } }) => `
        width: 100%;
        margin-top: ${isMobile ? '16px' : '24px'};
        padding: ${isMobile ? '7.5px 16px' : '6px 16px'};
        color: ${colors.text.tertiary};
        font-size: ${
            isMobile ? typography.size.mobile.paragraph.p3 : typography.size.desktop.paragraph.p3
        };
        gap: ${isMobile ? '8px' : '32px'};
        & > div {
            &:nth-of-type(1) {
                width: ${isMobile ? '130px' : '130px'}; 
                justify-content: start;
            }
            &:nth-of-type(2) {
                width: ${isMobile ? '60px' : '80px'};
                justify-content: end;
            }
            &:nth-of-type(3) {
                width: ${isMobile ? '150px' : '160px'};
                justify-content: end;
            }
        }
    `}
`;

export const DrawerHoldingCoinListItem = styled(StyledFlexContainer)`
    ${({ theme: { typography, breakpoints, isMobile } }) => `
        width: 100%;
        gap: ${isMobile ? '8px' : '32px'};
        & > div {
            &:nth-of-type(1) {
                width: ${isMobile ? '130px' : '130px'}; 
                justify-content: start;
                font-size: ${
                    isMobile
                        ? typography.size.mobile.paragraph.p1
                        : typography.size.desktop.paragraph.p2
                };
                line-height: ${typography.lineHeight[5]};
                font-weight: ${typography.weight.semiBold};
                & > img {
                    width: 20px;
                    height: 20px;
                }
            }
            &:nth-of-type(2) {
                width: ${isMobile ? '60px' : '80px'};
                justify-content: end;
            }
            &:nth-of-type(3) {
                width: ${isMobile ? '150px' : '160px'};
                justify-content: end;
            }
            &:nth-of-type(2), &:nth-of-type(3) {
                font-size: ${
                    isMobile
                        ? typography.size.mobile.paragraph.p1
                        : typography.size.desktop.paragraph.p2
                };
                line-height: ${typography.lineHeight[6]};
                @media (max-width: ${breakpoints.md}) {
                    & > span {
                        &:nth-of-type(2) {
                            font-size: ${typography.size.mobile.paragraph.p2};
                            line-height: ${typography.lineHeight[2]};
                        }
                    }
                }
            }
        }
    `}
`;
